// Suscripción a Web Push: permite recibir alertas del proceso (nueva entrada,
// inspección pendiente, salida registrada, ticket creado) aunque la app SISP
// no esté abierta en el navegador.
import api from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export const pushManager = {
  isSupported: () =>
    'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window,

  permission: () => (typeof Notification !== 'undefined' ? Notification.permission : 'unsupported'),

  // Pide permiso y suscribe el dispositivo. Devuelve true si quedó activo.
  enable: async () => {
    if (!pushManager.isSupported()) return false;
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return false;

      const registration = await navigator.serviceWorker.ready;
      const { data } = await api.get('/push/vapid-public-key');
      if (!data?.publicKey) return false;

      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(data.publicKey),
        });
      }

      await api.post('/push/subscribe', subscription.toJSON());
      return true;
    } catch (e) {
      console.warn('No se pudo activar notificaciones push:', e);
      return false;
    }
  },

  // Revisa si ya hay permiso concedido y (re)asegura la suscripción en el
  // backend, en silencio (sin pedir permiso de nuevo).
  ensureIfGranted: async () => {
    if (!pushManager.isSupported()) return;
    if (Notification.permission !== 'granted') return;
    await pushManager.enable();
  },
};
